var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoiceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1191",
    "data-name": "Ellipse 1191",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(11960.158 351)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SON",
    transform: "translate(-11960.158 -351)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(11960.158 351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_68",
    "data-name": "Groupe de masques 68",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13245",
    "data-name": "Trac\\xE9 13245",
    d: "M99.879,256.122a1.562,1.562,0,0,1-1.108-.459,13.819,13.819,0,0,1,0-19.521,1.567,1.567,0,0,1,2.216,2.216,10.681,10.681,0,0,0,0,15.088,1.567,1.567,0,0,1-1.108,2.676Z",
    transform: "translate(11882.883 136.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13246",
    "data-name": "Trac\\xE9 13246",
    d: "M173.286,292.723a1.562,1.562,0,0,1-1.108-.459,6.974,6.974,0,0,1,0-9.851,1.567,1.567,0,0,1,2.216,2.216,3.836,3.836,0,0,0,0,5.418,1.567,1.567,0,0,1-1.108,2.676Z",
    transform: "translate(11815.355 94.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13247",
    "data-name": "Trac\\xE9 13247",
    d: "M26.788,220.517a1.562,1.562,0,0,1-1.108-.459,20.478,20.478,0,0,1,0-28.927,1.567,1.567,0,1,1,2.216,2.216,17.34,17.34,0,0,0,0,24.494,1.567,1.567,0,0,1-1.108,2.676Z",
    transform: "translate(11950.078 176.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13248",
    "data-name": "Trac\\xE9 13248",
    d: "M245.015,53.5a1.567,1.567,0,0,1-1.429-.923L241.473,47.9a1.992,1.992,0,0,0-1.85-1.172c-2.783.049-6.2.1-7.944.066a4.673,4.673,0,0,1-3.557-1.5,4.549,4.549,0,0,1-1.051-3.526,1.8,1.8,0,0,0-.557-1.588,4.383,4.383,0,0,1-.911-1.621,2.9,2.9,0,0,1,1.086-3.015,1.612,1.612,0,0,1,.133-.093l3.149-1.981-4.707-1.786q-.06-.023-.118-.051a2.743,2.743,0,0,1-1.513-2.988l.609-3.2a1.206,1.206,0,0,0-1.009-1.419l-3.1-.455a2.6,2.6,0,0,1-1.861-3.89l5.906-10.024a7.824,7.824,0,0,0,1-5.08l-.405-2.786a1.567,1.567,0,0,1,3.1-.451l.405,2.786a10.969,10.969,0,0,1-1.4,7.123l-5.5,9.338,2.311.34a4.34,4.34,0,0,1,3.632,5.106l-.546,2.868,5.29,2.007a2.612,2.612,0,0,1,.464,4.654l-3.781,2.378c.066.092.149.2.223.29a4.876,4.876,0,0,1,1.221,3.848,1.525,1.525,0,0,0,.276,1.134,1.771,1.771,0,0,0,1.274.442c1.692.033,5.072-.017,7.828-.066a5.129,5.129,0,0,1,4.762,3.016l2.113,4.679a1.568,1.568,0,0,1-1.428,2.213ZM230.95,33.841h0Z",
    transform: "translate(11772.576 347.251)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceIcon);
export default __webpack_public_path__ + "static/media/voice_icon.f31ec738.svg";
export { ForwardRef as ReactComponent };